/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import Links from "./Routes/Routes";
import {CustomNavigationClient} from "./auth/authConfig";
import {MsalProvider} from '@azure/msal-react';
import {useNavigate} from "react-router-dom";
import {IPublicClientApplication} from "@azure/msal-browser";
import './css/Table-Styling.css'

type AppProps = {
  pca: IPublicClientApplication;
};
//
function App({pca}: AppProps) {
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  pca.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={pca}>
      <Links/>
    </MsalProvider>
  );
}

export default App;
